module.exports = __webpack_public_path__ + "img/Huawei-app-gallery-1.6d54a0bc.png";